import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  companyNameCPS: PropTypes.string.isRequired,
  companyNameAliases: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  className: PropTypes.string,
};

const CompanyDisclaimerSection = ({ className, companyNameCPS, companyNameAliases }) => {
  const aliasString = useMemo(() => {
    let aliasString = '';
    for (let i = 0; i < companyNameAliases?.length; i++) {
      if (i !== 0) aliasString += i === companyNameAliases.length - 1 ? ' and ' : ', ';
      aliasString += companyNameAliases[i];
    }
    return aliasString;
  }, [companyNameAliases]);

  return (
    <section id="Disclaimer" className={className}>
      <p className="z-font-13 z-text-secondary">
        {`Zippia gives an in-depth look into the details of ${companyNameCPS}, including salaries, political affiliations, employee data, and more, in order to inform job seekers about ${companyNameCPS}. The employee data is based on information from people who have self-reported their past or current employments at ${companyNameCPS}.  The data on this page is also based on data sources collected from public and open data sources on the Internet and other locations, as well as proprietary data we licensed from other companies.  Sources of data may include, but are not limited to, the BLS, company filings, estimates based on those filings, H1B filings, and other public and private datasets. While we have made attempts to ensure that the information displayed are correct, Zippia is not responsible for any errors or omissions or for the results obtained from the use of this information. None of the information on this page has been provided or approved by ${companyNameCPS}. The data presented on this page does not represent the view of ${companyNameCPS} and its employees or that of Zippia.`}
      </p>
      {!!aliasString && (
        <p className="z-font-13 z-text-secondary">{`${companyNameCPS} may also be known as or be related to ${aliasString}${
          aliasString[aliasString.length - 1] === '.' ? '' : '.'
        }`}</p>
      )}
    </section>
  );
};

CompanyDisclaimerSection.propTypes = propTypes;

export default CompanyDisclaimerSection;
